import React from 'react';
import './Layout.css';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  currentView?: string;
  onNavigate?: (view: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, currentView, onNavigate }) => {
  return (
    <div className="layout">
      <Header />
      <div className="layout-body">
        <Sidebar currentView={currentView} onNavigate={onNavigate} />
        <main className="layout-main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
